module.exports = __webpack_public_path__ + "static/media/webdesign-services-img39.19af63b2.jpg";